import { gql } from 'apollo-boost';

const FRAGMENT_ROLE_PERMISSION = gql`
  fragment FragmentRolePermission on RolePermission {
    id
    originId
    name
    slug
    operations
  }
`;

const FRAGMENT_ACADEMIC_YEAR = gql`
  fragment FragmentLoginAcademicYear on AcademicYear {
    id
    name
    fromYear
    toYear
    isEnabled
    isCurrent
    isSyncedFromGroupLevel
    editInfo {
      updatedAt
      createdAt
    }
    flexibilityControlInfo {
      inventoryThresholdForUrgencyMessage
      maxRequestsForEachStudent
      setUpRateType
    }
  }
`;

const FRAGMENT_USER_ROLE = gql`
  fragment FragmentUserRole on UserRole {
    id
    role {
      id
      originId
      name
      isAdmin
      permissions {
        ...FragmentRolePermission
        childPermissions {
          ...FragmentRolePermission
          childPermissions {
            ...FragmentRolePermission
            childPermissions {
              ...FragmentRolePermission
            }
          }
        }
      }
    }
    accessScope {
      landlords {
        id
        name
        properties {
          id
          name
        }
        groupAcademicYears {
          id
          name
          fromYear
          toYear
        }
      }
      properties {
        id
        name
        currency
        timezone
        billingCycle
        contactEmailAddress
        areaUnitOfMeasurement
        ownerName
        landlord {
          id
          name
        }
        topLandlord {
          id
          name
        }
        city {
          id
          name
        }
        landlord {
          id
        }
        academicYear {
          past {
            ...FragmentLoginAcademicYear
          }
          current {
            ...FragmentLoginAcademicYear
          }
        }
      }
    }
  }
  ${FRAGMENT_ROLE_PERMISSION}
  ${FRAGMENT_ACADEMIC_YEAR}
`;

export const VIEWER = gql`
  query QueryViewer {
    viewer {
      id
      name
      email
      level
      processingTicketsCount
      landlord {
        id
        name
      }
      topLandlord {
        id
        name
      }
      property {
        id
        name
      }
      currentRole {
        ...FragmentUserRole
      }
      roles {
        ...FragmentUserRole
      }
      userPersonalPreference {
        id
        bookingFilters {
          status
        }
        defaultBookingListView
        editInfo {
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
      }
    }
  }
  ${FRAGMENT_USER_ROLE}
`;

export const LOGIN = gql`
  mutation MutationLogin($email: String!, $password: String!, $topLandlordId: ID!) {
    login(email: $email, password: $password, topLandlordId: $topLandlordId) {
      authToken
    }
  }
`;

export const USER_FORGOT_PASSWORD = gql`
  mutation MutationUserForgotPassword($email: String!, $topLandlordId: ID!) {
    userForgotPassword(email: $email, topLandlordId: $topLandlordId) {
      success
    }
  }
`;

export const RESET_USER_PASSWORD = gql`
  mutation MutationResetUserPassword($token: String!, $password: String!) {
    resetUserPassword(token: $token, password: $password) {
      success
    }
  }
`;

export const QUERY_SSO_URL = gql`
  query QuerySSO_URL($provider: SSOProviders!, $topLandlordId: ID!) {
    getSSOUrl(provider: $provider, topLandlordId: $topLandlordId) {
      redirectUrl
    }
  }
`;

export const SSO_LOGIN = gql`
  mutation MutationSSOLogin($input: SSOLoginInput) {
    SSOLogin(input: $input) {
      authToken
    }
  }
`;

export const QUERY_GET_PMS_PORTAL_CONFIG = gql`
  query GetPMSPortalConfig {
    getPMSPortalConfig {
      topLandlordId
    }
  }
`;
